import { identity, prop } from 'ramda'
import React from 'react'

import { Label, Text } from '../presentation/Text'
import FlexGrid from '../structure/FlexGrid'
import Separator from '../helpers/Separator'
import _Input from './Input'
import { COLORS } from '@btime/constants'

const FormItem = ({
  Input = _Input,
  value,
  label,
  form,
  fieldErrors,
  field,
  t = identity,
  handleChange,
  weight = 4,
  children,
  tourStep,
  right,
  ...props
}) => {
  const error = prop(field, fieldErrors)
  label = t(label || field)
  value = value || prop(field, form)

  return (
    <div datatour={tourStep}>
      <FlexGrid gutter={0.2} justify="space-between">
        <Label>{label}</Label>
        {right}
      </FlexGrid>
      {children || <Input value={value} onChange={handleChange(field)} t={t} {...props} />}
      <Text color={COLORS.red}>{error}</Text>
      <Separator weight={weight} />
    </div>
  )
}

export default FormItem
